import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';
import { ButtonType, CallToActionKind } from '@/types';
import { FC } from 'react';

import styles from './ModalFooter.ds.module.scss';

type buttonModal = {
  label?: string;
  action?: (arg?: unknown) => void;
  type?: ButtonType;
  formId?: string;
}
export type ModalFooterDsProps = {
  confirm?: buttonModal;
  cancel?: buttonModal;
  sticky?: boolean;
  groupVariant?: 'primary' | 'secondary' | 'tertiary';
  direction?: 'column' | 'row';
}

export const ModalFooterDs: FC<ModalFooterDsProps> = (
  { confirm, cancel, sticky = false, groupVariant = 'primary', direction = 'row' }
) => {
  const buttonsVariant = (() => {
    switch (groupVariant) {
      case 'primary':
        return [CallToActionKind.PRIMARY, CallToActionKind.TERTIARY];
      case 'secondary':
        return [CallToActionKind.PRIMARY, CallToActionKind.SECONDARY];
      case 'tertiary':
        return [CallToActionKind.SECONDARY, CallToActionKind.TERTIARY];
    }
  })();

  const containerClassNames = [
    sticky ? styles.sticky : styles.footer,
    direction === 'column' ? styles.column : ''
  ].join(' ');

  return (
    <div className={containerClassNames} data-test-id="modal-footer">
      {confirm?.label && (
        <CallToActionContainer
          id="confirm-btn"
          onClick={confirm?.action && (() => confirm?.action?.())}
          type={confirm.type}
          kind={buttonsVariant[0]}
          form={confirm.formId}
          fullWidth
        >
          {confirm.label}
        </CallToActionContainer>
      )}

      {cancel?.label && (
        <CallToActionContainer
          id="cancel-btn"
          onClick={() => cancel?.action?.()}
          kind={buttonsVariant[1]}
          fullWidth
        >
          {cancel.label}
        </CallToActionContainer>
      )}
    </div>
  );
};

export default ModalFooterDs;
